@if (!DownloadInformation.downloading) {
  <a class="inline-flex cursor-pointer text-theme-primary-700 hover:text-theme-primary-900 justify-self-end">
      <span class="place-self-center pr-2" [ngClass]="{'text-sm md:text-lg': OverrideTextSize}"
            (click)="Download()">
        {{ Text }}
      </span>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         class="bi bi-download place-self-center" viewBox="0 0 16 16">
      <path
        d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
      <path
        d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
    </svg>
  </a>
} @else {
  <svg class="bi bi-arrow-repeat animate-spin" height="24"
       viewBox="0 0 16 16"
       width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
    <path
      d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
      fill-rule="evenodd"/>
  </svg>
}

